import "@hotwired/turbo-rails"
Turbo.session.drive = false

document.addEventListener("turbo:frame-load", (event) => {
  bcn.init();
})

console.log("Starting Turbo")
Turbo.start()
console.log("Turbo Started")